export default {
  name: 'MwDoubleFace',
  props: {
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  template: `
    <div @click="this.handleClick">
      <div v-show="editable">
        <slot name="editable"></slot>
      </div>

      <div v-show="!editable">
        <slot name="readonly"></slot>
      </div>
    </div>
  `,

  data() {
    return {
      editable: false
    }
  },

  mounted() {
    $(document.body).on('click', this.hijackClick);
  },

  beforeDestroy() {
    $(document.body).off('click', this.hijackClick);
  },

  methods: {
    handleClick() {
      if (this.readOnly) return;
      this.editable = true;
      this.$nextTick(() => {
        $(this.$el).find('input, textarea, select').focus();
      });
    },

    handleBlur() {
      this.editable = false;
    },

    hijackClick(e) {
      if (!this.editable) return
      const target = e.target;
      const $target = $(target);

      if (!this.$el.contains(target)) {
        if ($target.parents('.el-select-dropdown,.el-picker-panel').length === 0) {
          this.handleBlur();
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/index/components/double-face/index.js